var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 37.3333C15.2971 37.3333 14.6305 37.1619 14.117 36.8533L1.883 29.4667C0.82677 28.8305 0 27.3295 0 26.0571V11.28C0 10.0038 0.82677 8.50667 1.883 7.87048L14.117 0.48C14.6305 0.171429 15.3007 0 16 0C16.7029 0 17.3695 0.171429 17.883 0.48L30.117 7.86667C31.1732 8.50286 32 10.0038 32 11.2762V26.0533C32 27.3295 31.1732 28.8267 30.117 29.4629L17.883 36.8533C17.3695 37.1619 16.7029 37.3333 16 37.3333Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1106 6.78906C19.7597 6.78906 22.7225 9.75944 22.7225 13.425C22.7225 17.0906 19.7597 20.061 16.1106 20.061C12.4583 20.061 9.4987 17.0906 9.4987 13.425C9.4987 9.75944 12.4583 6.78906 16.1106 6.78906ZM16.1106 30.0149C10.4936 30.0149 8 27.6923 8 27.2309C8 25.0126 8.83751 22.927 10.2292 21.3692C11.7908 22.709 13.8405 23.5496 16.1106 23.5496C18.3901 23.5496 20.4461 22.7059 22.0141 21.3565C23.3931 22.9207 24.2212 25.0126 24.2212 27.2309C24.2212 27.6923 21.7276 30.0149 16.1106 30.0149Z",
    fill: "#FCC800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.e83f1710b0d7e97e526317d0099efbb7.svg";
export { ForwardRef as ReactComponent };